export const applySoftMode = async (canvas, ctx, setMessage, language) => {
  // 진행 상황 업데이트
  setMessage(language === 'KR' ? '부드러운 모드 적용 중 (1/3) - 블러 효과 적용...' : 'Applying Soft Mode (1/3) - Adding blur effect...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // 부드러운 모드 효과 적용
  // 1. 약간의 블러 효과 적용
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  
  // 블러 효과를 위한 boxBlur 적용
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // 마일드한 박스 블러 적용
  const blurRadius = 1;
  
  for (let y = blurRadius; y < canvas.height - blurRadius; y++) {
    for (let x = blurRadius; x < canvas.width - blurRadius; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      for (let c = 0; c < 3; c++) {
        let sum = 0;
        let count = 0;
        
        // 주변 픽셀 평균 계산
        for (let dy = -blurRadius; dy <= blurRadius; dy++) {
          for (let dx = -blurRadius; dx <= blurRadius; dx++) {
            const neighborPos = ((y + dy) * canvas.width + (x + dx)) * 4;
            sum += tempData[neighborPos + c];
            count++;
          }
        }
        
        // 평균값 적용
        data[pos + c] = sum / count;
      }
    }
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 색상 톤 조정 (부드러운 파스텔 톤)
  setMessage(language === 'KR' ? '부드러운 모드 적용 중 (2/3) - 색감 조정...' : 'Applying Soft Mode (2/3) - Adjusting colors...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const toneData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const tonePixels = toneData.data;
  
  for (let i = 0; i < tonePixels.length; i += 4) {
    // 밝은 톤으로 조정
    tonePixels[i] = Math.min(255, tonePixels[i] * 0.9 + 25);
    tonePixels[i + 1] = Math.min(255, tonePixels[i + 1] * 0.9 + 25);
    tonePixels[i + 2] = Math.min(255, tonePixels[i + 2] * 0.9 + 25);
    
    // 콘트라스트 약간 감소
    for (let c = 0; c < 3; c++) {
      const value = tonePixels[i + c];
      tonePixels[i + c] = 128 + (value - 128) * 0.85;
    }
  }
  
  ctx.putImageData(toneData, 0, 0);
  
  // 3. 글로우 효과 추가
  setMessage(language === 'KR' ? '부드러운 모드 적용 중 (3/3) - 글로우 효과 추가...' : 'Applying Soft Mode (3/3) - Adding glow effect...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // 글로우 효과를 위한 강한 블러 버전 생성
  tempCtx.clearRect(0, 0, tempCanvas.width, tempCanvas.height);
  tempCtx.filter = 'blur(8px)';
  tempCtx.drawImage(canvas, 0, 0);
  
  // 원본과 블러 이미지 혼합
  ctx.globalAlpha = 0.3; // 블러 이미지의 투명도
  ctx.drawImage(tempCanvas, 0, 0);
  ctx.globalAlpha = 1.0; // 투명도 초기화
  
  // 처리 완료
  setMessage(language === 'KR' ? '부드러운 모드 적용 완료!' : 'Soft Mode applied!');
};